import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class LimiteCobrancaService extends Service {
  async consultarLimites () {
    let limites = [];
    const brancoAcoes = '';
    let result = await this.getLimiteCobrancaApi().consultarLimites();
    result.map(res => {
      const { codVigencia, valPercentual, dtaInicio, dtaFim, txtObservacao } = res;
      limites.push(Object.values({ codVigencia, valPercentual, dtaInicio, dtaFim, txtObservacao, brancoAcoes }));
    });
    return limites || [];
  }
  async consultarUltimoLimite () {
    let ultimoLimite = await this.getLimiteCobrancaApi().consultarUltimoLimite();
    return ultimoLimite;
  }
  async incluirLimite (limite) {
    let result = await this.getLimiteCobrancaApi().incluirLimite(limite);
    return result;
  }
  async excluirLimite (codVigencia) {
    let result = await this.getLimiteCobrancaApi().excluirLimite(codVigencia);
    return result;
  }
  async alterarLimite (limite) {
    let result = await this.getLimiteCobrancaApi().alterarLimite(limite);
    return result;
  }
}
export default LimiteCobrancaService;
